export default __webpack_public_path__ + "static/media/DaimlerCS-Regular.54ea21cc.eot";